import { render, staticRenderFns } from "./StampSetting.vue?vue&type=template&id=4187f84f&scoped=true&"
import script from "./StampSetting.vue?vue&type=script&lang=js&"
export * from "./StampSetting.vue?vue&type=script&lang=js&"
import style0 from "./StampSetting.vue?vue&type=style&index=0&id=4187f84f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187f84f",
  null
  
)

export default component.exports